export const environment = {
  production: false,
  apiUrl: 'https://api.auth.test.bassetti-ites.in/api/v1/auth',
  refreshToken: 'rf_tkn',
};
